import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import useConfig from 'app/hooks/useConfig';
import Impressum from './Impressum';
import LegalInformation from './LegalInformation';
import B2B from './B2B';
import PriceList from './PriceList';
import BonusCard from './BonusCard';
import FamilyFilmClub from './FamilyFilmClub';
import BirthdayRoom from './BirthdayRoom';
import GiftCardInfo from './GiftCard';
import Competition from './Competition';
import CompetitionDetail from './CompetitionDetail';
import HallTicket from './HallTicket';
import PrivacyPolicy from './PrivacyPolicy';
const Info = () => {
  const { routes } = useConfig();

  return (
    <Switch>
      <Route path={routes.impressum.pattern} component={Impressum} />
      <Route path={routes.legal.pattern} component={LegalInformation} />
      <Route path={routes.privacy.pattern} component={PrivacyPolicy} />
      <Route path={routes.b2b.pattern} component={B2B} />
      <Route path={routes.priceList.pattern} component={PriceList} exact />
      <Route path={routes.gastorPriceList.pattern} component={PriceList} exact />
      <Route path={routes.priceListt.pattern} component={PriceList} exact />
      <Route path={routes.bonusCardInfo.pattern} component={BonusCard} />
      <Route path={routes.giftCardInfo.pattern} component={GiftCardInfo} />
      <Route path={routes.competitionInfo.pattern} component={Competition} />
      <Route path={routes.competitionDetail.pattern} component={CompetitionDetail} />
      <Route path={routes.familyFilmClub.pattern} component={FamilyFilmClub} />
      <Route path={routes.birthdayRoom.pattern} component={BirthdayRoom} />
      <Route path={routes.hallInfo.pattern} component={HallTicket} />
      <Redirect from={routes.info.pattern} to={routes.impressum.pattern} />
    </Switch>
  );
};

export default Info;
